import React, { useState } from 'react';
import { ThemeProvider } from '@mui/material/styles';
import theme from '../styles/AdminPortal';
import Login from '../components/Login';
import Dashboard from '../components/Dashboard';

function AdminPortal() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  const handleLogin = () => {
    setIsAuthenticated(true);
  };

  return (
    <ThemeProvider theme={theme}>
      <div className="ap-admin-portal">
        {isAuthenticated ? <Dashboard /> : <Login onLogin={handleLogin} />}
      </div>
    </ThemeProvider>
  );
}

export default AdminPortal;